// Environment configuration
export const env = {
  // API Configuration
  API_BASE_URL: import.meta.env.VITE_API_BASE_URL || 'https://api.moova.tv',
  API_VERSION: import.meta.env.VITE_API_VERSION || 'v1',
  
  // Stripe
  STRIPE_PUBLISHABLE_KEY: import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY || '',

  // Cloudflare Turnstile
  TURNSTILE_SITE_KEY: import.meta.env.VITE_TURNSTILE_SITE_KEY || '1x00000000000000000000AA',
  
  // App Configuration
  APP_NAME: import.meta.env.VITE_APP_NAME || 'MoovaTV',
  APP_VERSION: import.meta.env.VITE_APP_VERSION || '1.0.0',
  APP_ENV: import.meta.env.MODE || 'development',
  
  // Feature Flags
  ENABLE_MOCK_API: import.meta.env.VITE_ENABLE_MOCK_API === 'true' || import.meta.env.MODE === 'development',
  ENABLE_DEBUG: import.meta.env.VITE_ENABLE_DEBUG === 'true' || import.meta.env.MODE === 'development',
  
  // Upload Configuration
  MAX_FILE_SIZE: parseInt(import.meta.env.VITE_MAX_FILE_SIZE || '10485760'), // 10MB default
  ALLOWED_FILE_TYPES: (import.meta.env.VITE_ALLOWED_FILE_TYPES || '.m3u,.m3u8').split(','),
  
  // Pagination
  DEFAULT_PAGE_SIZE: parseInt(import.meta.env.VITE_DEFAULT_PAGE_SIZE || '20'),
  
  // Cache Configuration
  CACHE_TTL: parseInt(import.meta.env.VITE_CACHE_TTL || '300000'), // 5 minutes default
  
  // Development helpers
  isDevelopment: import.meta.env.MODE === 'development',
  isProduction: import.meta.env.MODE === 'production',
  isTest: import.meta.env.MODE === 'test',
} as const;

// Validation
if (env.isProduction && env.ENABLE_MOCK_API) {
  console.warn('Mock API is enabled in production environment');
}

// Export individual configs for convenience
export const apiConfig = {
  baseUrl: env.API_BASE_URL,
  version: env.API_VERSION,
  enableMock: env.ENABLE_MOCK_API,
} as const;

export const uploadConfig = {
  maxFileSize: env.MAX_FILE_SIZE,
  allowedFileTypes: env.ALLOWED_FILE_TYPES,
} as const;

export const cacheConfig = {
  ttl: env.CACHE_TTL,
} as const;
